module.exports = __webpack_public_path__ + "img/q4-3-active.6b8fbc4f.png";